const textStyle = {
    SignInStyle : {
        fontWeight: "900",
        fontSize: "72px",
        lineHeight: "80px",
        fontFamily: "Open Sans",
        textTransform: "uppercase"
    },
    dividerStyle : {
        backgroundColor : 'orange'
    }
}
export default textStyle